/**
 * frontend-log-store.js
 * フロントエンドログ送信に関連するデータストア
 */

// フロントエンドログ関連APIリクエスト用I/F
import frontendLogInterface from '@/api/frontend-log/frontend-log-interface'
// フロントエンドログ関連API
import frontendLogApi from '@/api/frontend-log/frontend-log-api'

export default {
  namespaced: true,
  state: {
  },
  actions: {
    /**
     * 操作ログ送信
     * @param {Object} param0 ストアオブジェクト
     * @param {Object} logData ログデータ
     */
    sendSystemLog ({commit}, logData) {
      try {
        const systemLogIf = new frontendLogInterface()
        const payload = systemLogIf.makeSendSystemLogPayload(logData)
        frontendLogApi.sendSystemLog(payload)
          .catch(error => {
            throw error
          })
      } catch (error) {
        throw error
      }
    },
    /**
     * 求職者ログ送信
     * @param {Object} param0 ストアオブジェクト
     * @param {Object} logData ログデータ
     */
    sendSeekerLog ({commit}, logData) {
      try {
        const systemLogIf = new frontendLogInterface()
        const payload = systemLogIf.makeSendSeekerLogPayload(logData)
        frontendLogApi.sendSeekerLog(payload)
          .catch(error => {
            throw error
          })
      } catch (error) {
        throw error
      }
    },
  },
  mutations: {
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/frontend-log/frontend-log-store.js